import { Stack, type StackProps, styled } from '@mui/material'
import type { ComponentType } from 'react'

export type RootProps = StackProps

export const Root = styled(Stack, {
  slot: 'Root',
})<RootProps>(({ theme: { spacing } }) => ({
  position: 'relative',
  gap: spacing(1),
})) as ComponentType<RootProps>
